import styled from '@emotion/styled'
import * as v from '../../../variables/styles'

export const NotFoundContainer = styled.div((props)=>({
  display:'flex',
  flex:1,
  flexDirection:'column',
  justifyContent:'center',
  alignItems:'center',

  '.text':{
    fontWeight:'bold',
    fontSize: '2.25rem'
  }
}))

export const CoverImgContainer = styled.div((props)=>({
  display:'flex',
  flexDirection:'column',

  '.imgBorder':{
    borderRadius:10,
    border:'1px solid #EAEFF5',
  },

  '.notfoundImg':{
    display:'flex',
    width:200,
    height:200,
    justifyContent:'center',
    alignItems:'center',
    marginBottom:5,
  },

  '.ui.button, i.icon': {
    margin:0
  }
}))

export const MediaContainer = styled.div((props)=>({
  display:'flex', 
  flexDirection:'column',
  alignItems:'center',
  
}))

export const MediaNotFoundContainer = styled.div((props)=>({
  display:'flex', 
  flexDirection:'column',
  alignItems:'center',

  '.text':{
    fontWeight:'bold',
    fontSize: '1.5rem'
  },  
}))

export const AttachFileContainer = styled.div((props)=>({
  display: 'flex',
}))

export const ItemNotFoundContainer = styled.div((props)=>({
  display:'flex', 
  alignItems: 'center',
  flexDirection: 'column',

  '.text':{
    fontWeight:'bold',
    fontSize: '1.5rem',
    color: '#8D8D8D',
  },  
}))